import { render, staticRenderFns } from "./Classic.vue?vue&type=template&id=b850e428&"
import script from "./Classic.vue?vue&type=script&lang=ts&"
export * from "./Classic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports